import { useState } from "react"

//PrimeReact
import { Accordion, AccordionTab } from "primereact/accordion"
import { Dropdown } from "primereact/dropdown"
import { Calendar } from "primereact/calendar"

//Housing Styles and components
import myStyle from "../../../styles/housing/HousingNotes.module.css"
import { useCallback } from "react"
import { useEffect } from "react"

export default function HousingNotesFilter({
  participants,
  participant,
  onSetParticipant,
  isLoading,
  houseList,
  onRefreshClick,
  onNewClick,
  onChangeFilters,
}) {
  const [houseId, setHouseId] = useState("")
  const [fromDate, setFromDate] = useState(undefined)
  const [toDate, setToDate] = useState(new Date())
  const [filterParticipant, setFilterParticipant] = useState(undefined)

  const setDefaultDates = useCallback(() => {
    let startDate = new Date()
    startDate.setDate(1)
    startDate.setMonth(startDate.getMonth() - 1)

    setFromDate(startDate)
  }, [])

  useEffect(() => {
    setDefaultDates()
  }, [setDefaultDates])

  useEffect(() => {
    setFilterParticipant(participant)
  }, [participant])

  const FilterHeader = () => {
    return (
      <div className={myStyle.filterHeaderGridContainer}>
        <div className={myStyle.filterHeaderGridTitle}>
          <label>{`Filters`}</label>
        </div>
        <div className={myStyle.filterHeaderGridButtons}>
          <div className={myStyle.filterButtonContainer}>
            {!!onRefreshClick ? (
              <button
                type="button"
                className={`btn t-tip ${myStyle.filterHeaderButton}`}
                onClick={(e) => {
                  e.stopPropagation()
                  if (!!onRefreshClick) {
                    onRefreshClick()
                  }
                }}
                disabled={isLoading}
              >
                <span className={`material-icons`}>{"autorenew"}</span>
                {" Reload data"}
              </button>
            ) : null}
            <button
              type="button"
              className={`btn t-tip ${myStyle.filterHeaderButton}`}
              onClick={(e) => {
                e.stopPropagation()
                if (!!onNewClick) {
                  onNewClick()
                }
              }}
              disabled={isLoading}
            >
              <span className={`material-icons`}>{"add"}</span>
              {" Add new note"}
            </button>
          </div>
        </div>
      </div>
    )
  }
  return (
    <>
      <Accordion style={{ marginBottom: "10px" }} activeIndex={0}>
        <AccordionTab
          header={FilterHeader()}
          disabled={isLoading}
          headerClassName={myStyle.filterHeader}
        >
          <div className={myStyle.filterBodyGridContainer}>
            <div className={myStyle.filterBodyGridHouse}>
              <div className={myStyle.label}>House</div>
              <div>
                <Dropdown
                  className={`${myStyle.input}`}
                  value={houseId}
                  onChange={(e) => {
                    setHouseId(e.value)
                  }}
                  placeholder="All houses"
                  options={houseList}
                  optionLabel={"name"}
                  optionValue={"id"}
                  disabled={isLoading}
                  filter
                  showClear
                />
              </div>
            </div>

            <div className={myStyle.filterBodyGridFrom}>
              <div className={myStyle.label}>From Date</div>
              <div>
                <Calendar
                  className={myStyle.input}
                  value={fromDate}
                  onChange={(e) => {
                    setFromDate(e.value)
                  }}
                  maxDate={toDate}
                  disabled={isLoading}
                />
              </div>
            </div>
            <div className={myStyle.filterBodyGridTo}>
              <div className={myStyle.label}>To Date</div>
              <div>
                <Calendar
                  className={myStyle.input}
                  value={toDate}
                  onChange={(e) => {
                    setToDate(e.value)
                  }}
                  minDate={fromDate}
                  disabled={isLoading}
                />
              </div>
            </div>
            <div className={myStyle.filterBodyGridParticipants}>
              <div className={myStyle.label}>Participant</div>
              <Dropdown
                className={`${myStyle.input}`}
                value={filterParticipant}
                onChange={(e) => {
                  if (!!e.value.participant_id) {
                    setFilterParticipant(e.value)
                  } else {
                    setFilterParticipant(undefined)
                  }
                }}
                placeholder="All participants"
                options={[
                  { name2: "All participant", participant_id: undefined },
                  { name2: "Manager log", participant_id: "-1" },
                  ...participants,
                ]}
                optionLabel={"name2"}
                disabled={isLoading}
                filter
              />
            </div>
            <div className={myStyle.filterBodyGridButtons}>
              <div className={myStyle.filterButtons}>
                <button
                  className="btn"
                  type="button"
                  onClick={() => {
                    onChangeFilters({
                      houseId: houseId,
                      fromDate: fromDate,
                      toDate: toDate,
                      participantId: filterParticipant?.participant_id,
                    })

                    if (
                      !!filterParticipant?.participant_id &&
                      filterParticipant.participant_id !== "-1"
                    ) {
                      onSetParticipant(filterParticipant)
                    } else {
                      onSetParticipant(undefined)
                    }
                  }}
                  disabled={isLoading}
                >
                  Apply
                </button>
                <button
                  className={`btn ${myStyle.filterButton}`}
                  type="button"
                  onClick={() => {
                    setHouseId(undefined)
                    setFromDate(undefined)
                    setToDate(new Date())
                    setFilterParticipant(undefined)
                    onChangeFilters({
                      status: "Due",
                      houseId: undefined,
                      fromDate: undefined,
                      toDate: new Date(),
                      participantId: undefined,
                    })

                    if (!!participant) {
                      onSetParticipant(undefined)
                    }
                  }}
                  disabled={isLoading}
                >
                  Reset
                </button>
              </div>
            </div>
          </div>
        </AccordionTab>
      </Accordion>
    </>
  )
}
